import { FC } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

type CheckboxProps = {
  label: string;
  id: string;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  register: UseFormRegisterReturn;
};

const Checkbox: FC<CheckboxProps> = ({ label, id, error, register }) => (
  <label
    htmlFor={id}
    className={`group checkbox cursor-pointer flex gap-2 mono`}
  >
    <span className="flex">
      <input
        id={id}
        type="checkbox"
        aria-invalid={!!error}
        {...register}
      />
    </span>
    <span className={`${error ? "opacity-100" : "opacity-60"}`}>{label}</span>
    <span
      role="alert"
      className={`text-red-500 ${error ? "opacity-100" : "opacity-0 visibility-hidden"}`}
    >
      *
    </span>
  </label>
);

export default Checkbox;
